class SitemapService {
  static async generateSitemap(baseUrl = window.location.origin, tcgs = []) {
    // Remove trailing slash if present
    baseUrl = baseUrl.replace(/\/$/, '');

    const currentDate = new Date().toISOString();

    // Define public routes with their metadata
    const routes = [
      {
        path: '/',
        changefreq: 'daily',
        priority: '1.0',
        lastmod: currentDate,
        title: 'Home - TCG API'
      },
      {
        path: '/docs',
        changefreq: 'weekly',
        priority: '0.9',
        lastmod: currentDate,
        title: 'API Documentation - TCG API'
      },
      {
        path: '/login',
        changefreq: 'monthly',
        priority: '0.5',
        lastmod: currentDate,
        title: 'Login - TCG API'
      },
      {
        path: '/register',
        changefreq: 'monthly',
        priority: '0.5',
        lastmod: currentDate,
        title: 'Register - TCG API'
      },
      {
        path: '/sitemap',
        changefreq: 'weekly',
        priority: '0.3',
        lastmod: currentDate,
        title: 'Sitemap - TCG API'
      }
    ];

    // Add TCG-specific documentation pages
    if (tcgs && tcgs.length > 0) {
      tcgs.forEach(tcg => {
        routes.push({
          path: `/docs/${tcg.name.toLowerCase()}`,
          changefreq: 'weekly',
          priority: '0.8',
          lastmod: currentDate,
          title: `${tcg.display_name} API Documentation - TCG API`
        });
      });
    }

    const xml = `<?xml version="1.0" encoding="UTF-8"?>
    <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
    ${routes.map(route => `<url>
        <loc>${baseUrl}${route.path}</loc>
        <lastmod>${route.lastmod}</lastmod>
        <changefreq>${route.changefreq}</changefreq>
        <priority>${route.priority}</priority>
      </url>`).join('\n')}
</urlset>`;

    return xml;
  }

  static generateRobotsTxt(baseUrl = window.location.origin) {
    // Remove trailing slash if present
    baseUrl = baseUrl.replace(/\/$/, '');

    const robotsTxt = `User-agent: *
Allow: /
Allow: /docs
Allow: /login
Allow: /register

# Block admin and user-specific areas
Disallow: /dashboard
Disallow: /api-keys
Disallow: /admin/

# Sitemap location
Sitemap: ${baseUrl}/sitemap.xml

# Crawl delay (optional)
Crawl-delay: 1`;

    return robotsTxt;
  }

  static getRouteMetadata(tcgs = []) {
    const routes = [
      {
        path: '/',
        title: 'TCG API - Trading Card Game Data API',
        description: 'Access comprehensive trading card game data through our powerful API. Supports Pokemon, Lorcana, and more TCGs.',
        keywords: 'TCG API, trading cards, pokemon, lorcana, card game data, API'
      },
      {
        path: '/docs',
        title: 'API Documentation - TCG API',
        description: 'Complete API documentation with examples, authentication guides, and endpoint reference for the TCG API.',
        keywords: 'API documentation, TCG endpoints, API reference, developer guide'
      },
      {
        path: '/login',
        title: 'Login - TCG API',
        description: 'Sign in to your TCG API account to manage your API keys and access usage statistics.',
        keywords: 'login, sign in, API account, authentication'
      },
      {
        path: '/register',
        title: 'Register - TCG API',
        description: 'Create a free TCG API account to get your API key and start accessing trading card game data.',
        keywords: 'register, sign up, create account, free API key'
      },
      {
        path: '/sitemap',
        title: 'Sitemap - TCG API',
        description: 'View all available pages and endpoints on the TCG API website.',
        keywords: 'sitemap, site map, navigation, website structure'
      }
    ];

    // Add TCG-specific documentation pages
    if (tcgs && tcgs.length > 0) {
      tcgs.forEach(tcg => {
        routes.push({
          path: `/docs/${tcg.name.toLowerCase()}`,
          title: `${tcg.display_name} API Documentation - TCG API`,
          description: `Dedicated API documentation for ${tcg.display_name} trading card data. Complete endpoint reference with examples and code samples.`,
          keywords: `${tcg.display_name.toLowerCase()}, ${tcg.name.toLowerCase()}, API documentation, trading cards, endpoints`
        });
      });
    }

    return routes;
  }

  static async downloadSitemap(tcgs = []) {
    const xml = await this.generateSitemap(window.location.origin, tcgs);
    const blob = new Blob([xml], { type: 'application/xml' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'sitemap.xml';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  static downloadRobotsTxt() {
    const robotsTxt = this.generateRobotsTxt();
    const blob = new Blob([robotsTxt], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'robots.txt';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}

export default SitemapService;